import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { completeLogout } from "../services/authService";

function SignOutCallback({ onComplete }) {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    completeLogout()
      .catch((error) => {
        // Callback can fail if OP omits expected params; continue local cleanup.
        console.error("Signout callback processing failed:", error);
      })
      .finally(() => {
        onComplete();
        if (isMounted) {
          navigate("/", { replace: true });
        }
      });

    return () => {
      isMounted = false;
    };
  }, [navigate, onComplete]);

  return <div className="loading-container">Signing you out...</div>;
}

export default SignOutCallback;
